import { Component, ViewEncapsulation, AfterViewChecked, OnInit } from '@angular/core';

import { Router, Event, NavigationError, NavigationEnd, ActivatedRoute, ParamMap } from '@angular/router';

import { BrowserService } from './browser.service';

import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent implements AfterViewChecked, OnInit {
  title = 'Dash';
  navbarOpen = false;
  selectedArticle = null;
  selectedSubArticle = null;
  fragment = null;
  overviewIllustration = 'room';
  noWebp = false;

  // IMPORTANT: copy these to test-guard.guard.ts when you change it
  topicTitles = {
    quickStart: 'Quick Start Guide',
    officeSetup: 'Office 365 Setup',
    googleSetup: 'Google Setup',
    deviceSetup: 'Android/iOS Setup',
    usingDash: 'Using Dash',
    practices: 'Practices'
  };
  officeSubArticles = {
    'o365-powershell' : 'Office 365 Powershell',
    'o365-enterprise-application': 'Enterprise Application',
    'o365-service-account': 'Service Account'
  };
  googleSubArticles = {
    'google-service-account': 'Google Workspace service account',
    'google-personal-account': 'Google Workspace or personal account'
  };


  objectKeys = Object.getOwnPropertyNames;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private browserService:BrowserService
  ) {
    router.events.subscribe( (event: Event) => {
        if (event instanceof NavigationEnd) {
           this.setArticleFromNavigation();
        } else if (event instanceof NavigationError) {
           console.log('error', event);
        }
    });
    this.browserService.addLoadListener(() => {
      this.noWebp = !this.browserService.supportsWebp();
    });
  }


  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  closeNavbar() {
    this.navbarOpen = false;
  }

  toggleOverviewIllustration(displayType) {
    if(displayType === 'room') {
      this.overviewIllustration = 'room';
    }
    else if(displayType === 'dashboard') {
      this.overviewIllustration = 'dashboard';
    }
  }

  setArticle(article) {
    if (typeof article !== 'undefined' && article !== null && this.topicTitles.hasOwnProperty(article)) {
      this.router.navigate(['/guide/' + article]);
      this.selectedArticle = article;
    }
    this.closeNavbar();
  }


  setArticleFromNavigation() {
    const article = this.route.snapshot.paramMap.get('id');

    if (typeof article !== 'undefined' && article !== null && this.topicTitles.hasOwnProperty(article)) {
      this.selectedArticle = article;
      this.selectedSubArticle = null;
    } else if (typeof article !== 'undefined' && article !== null && this.officeSubArticles.hasOwnProperty(article)) {
      this.selectedArticle = 'officeSetup';
      this.selectedSubArticle = article;
    } else if (typeof article !== 'undefined' && article !== null && this.googleSubArticles.hasOwnProperty(article)) {
      this.selectedArticle = 'googleSetup';
      this.selectedSubArticle = article;
    } else if (article === 'intro') {
      // default route for an invalid article
      this.selectedArticle = null;
      this.selectedSubArticle = null;
    } else {
      this.selectedArticle = null;
      this.selectedSubArticle = null;
    }
  }

  ngAfterViewChecked(): void {
    if (this.fragment) {
      const fragmentElement = document.getElementById(this.fragment);
      if (fragmentElement) {
        let yOffset = 0;

        const topBarElement = document.getElementById('topBar');
        if (topBarElement) {
          yOffset = topBarElement.getBoundingClientRect().top + topBarElement.getBoundingClientRect().height + 24;
        }

        const y = fragmentElement.getBoundingClientRect().top + window.pageYOffset - yOffset;
        window.scrollTo({top: y});
      }
      this.fragment = null;
    }

  }

  ngOnInit() {
    console.log('init');
    this.setArticleFromNavigation();
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }

}
